import { render, staticRenderFns } from "./ImportCSV.vue?vue&type=template&id=0d8c66a2&scoped=true&"
import script from "./ImportCSV.vue?vue&type=script&lang=js&"
export * from "./ImportCSV.vue?vue&type=script&lang=js&"
import style0 from "./ImportCSV.vue?vue&type=style&index=0&id=0d8c66a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8c66a2",
  null
  
)

export default component.exports